import {getRateByQuery, getRateParamById, loadRateDDLSource, getRateGroupByCustId, saveRate, deleteRate, synRateById, getHolidayByQuery, saveHoliday
  , deleteHoliday, synHolidayById, getTempRateByQuery, saveTempRate, deleteTempRate, synTempRateById} from '../../../api/rate.js'
const state = {
}
// mutations
const mutations = {
}
// actios
const actions = {
  getRateByQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getRateByQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRateParamById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getRateParamById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  loadRateDDLSource ({ commit }, param) {
    return new Promise((resolve, reject) => {
      loadRateDDLSource(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRateGroupByCustId ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getRateGroupByCustId(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveRate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveRate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteRate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteRate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synRateById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synRateById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getHolidayByQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getHolidayByQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveHoliday ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveHoliday(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteHoliday ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteHoliday(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synHolidayById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synHolidayById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getTempRateByQuery ({ commit }, param) {
    return new Promise((resolve, reject) => {
      getTempRateByQuery(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveTempRate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      saveTempRate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteTempRate ({ commit }, param) {
    return new Promise((resolve, reject) => {
      deleteTempRate(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  synTempRateById ({ commit }, param) {
    return new Promise((resolve, reject) => {
      synTempRateById(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/rate/rate.js